import React, { HTMLAttributes } from "react";
import PropTypes from "prop-types";

/** Data provider */
//import PubSub from "core/pubsub/pubsub-js.js";
import pubsub from "core/global/global";
import CustomEvent from "core/customEvent/index";

import MessageBox from "component/molecules/messageBox/index";
import HUGuideTableContainer from "component/molecules/HUGuideTable/HUGuideTableContainer";
//declare var pubsub: any;

interface IDialogSectionProps extends HTMLAttributes<HTMLDivElement> {}
interface IDialogSectionStates extends HTMLAttributes<HTMLDivElement> {
  isMessageBoxOpen: boolean;
  title: string;
  message: string;
  buttonType: any;
  hasCloseButton: boolean;
  hasTodayOffButton: boolean;
  handleYesClick: any;
  handleNoClick: any;
}

class DialogSection extends React.Component<
  IDialogSectionProps,
  IDialogSectionStates
> {
  static propTypes: PropTypes.InferProps<IDialogSectionProps>;

  /**
   * default property values
   *
   * @static
   * @memberof Viewport
   */
  static defaultProps = {};

  constructor(props: any) {
    super(props);

    this.state = {
      isMessageBoxOpen: false,
      hasTodayOffButton: false,
      title: "",
      message: "",
      buttonType: "CLOSE",
      hasCloseButton: false,
      handleYesClick: null,
      handleNoClick: null
    };
  }

  componentDidMount = () => {
    (pubsub as any).subscribe(
      CustomEvent.Messages.OPEN_MESSAGE_BOX,
      this.handleOpenMessageBox
    );
  };

  componentWillUnmount = () => {
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.OPEN_MESSAGE_BOX,
      this.handleOpenMessageBox
    );
  };

  handleOpenMessageBox = (payload: any, msg: any) => {
    const {
      title,
      message,
      buttonType,
      hasCloseButton,
      hasTodayOffButton,
      handleYesClick,
      handleNoClick
    } = payload;

    this.setState({
      title: title,
      message: message,
      buttonType: buttonType,
      hasCloseButton: hasCloseButton,
      isMessageBoxOpen: true,
      hasTodayOffButton: hasTodayOffButton,
      handleYesClick: handleYesClick,
      handleNoClick: handleNoClick
    });
  };

  render = () => {
    const {
      isMessageBoxOpen,
      title,
      message,
      buttonType,
      hasCloseButton,
      hasTodayOffButton,
      handleYesClick,
      handleNoClick
    } = this.state;
    return (
      <React.Fragment>
        <MessageBox
          open={isMessageBoxOpen}
          title={title}
          message={message}
          buttonType={buttonType}
          hasCloseButton={hasCloseButton}
          hasTodayOffButton={hasTodayOffButton}
          onClose={() => {
            this.setState({ isMessageBoxOpen: false });
          }}
          onYes={handleYesClick}
          onNo={handleNoClick}
        />
        <HUGuideTableContainer />
      </React.Fragment>
    );
  };
}

export default DialogSection;
